
        var result = require("!!../../../../node_modules/css-loader/index.js!./competitors.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/competitors/competitors.component.css
// module id = 1197
// module chunks = 0